export default __webpack_public_path__ + "static/media/service3.4fe30bb7.jpg";